import React from 'react';

const partners = [
  { name: 'Estado do Piauí', logo: 'https://s2-g1.glbimg.com/-MR80fiP9iOXkwqoisR9LhaHrVw=/0x0:852x469/984x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_59edd422c0c84a879bd37670ae4f538a/internal_photos/bs/2023/Y/j/SPWn0AR4qG91WIj3Bp6g/marca-pi.jpg' },
  { name: 'Estado de Roraima', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Bras%C3%A3o_de_Roraima.svg/1920px-Bras%C3%A3o_de_Roraima.svg.png' },
  { name: 'Porto Digital — Recife', logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Marca_Porto_Digital_2019_completa.png' },
  { name: 'Prefeitura de Palmas', logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d1/Bras%C3%A3o_de_Palmas_%28TO%29.png' },
];

const TrustBar = () => (
  <section className="py-12 bg-white border-b border-gray-100">
    <div className="container mx-auto px-6 md:px-12">
      <p className="text-center text-xs font-bold uppercase tracking-widest text-gray-400 mb-8">
        Órgãos públicos que confiam na Nexus
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-14 gap-y-8">
        {partners.map((p, i) => (
          <div key={i} className="flex items-center gap-3 opacity-80 hover:opacity-100 transition-opacity duration-200">
            <img src={p.logo} alt={p.name} className="h-16 w-auto max-w-[200px] object-contain" />
            <span className="text-sm font-semibold text-gray-600">{p.name}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBar;
